<template>
    <div>
        <h1>{{ $t('site.nav.donate') }}</h1>

        {{ $t('site.donate1') }} </br>
        {{ $t('site.donate2') }}
        <p>
        <h3>Direct Costs</h3>
        {{ $t('site.donateDirectHosting', ['$40']) }}<BR/>
        {{ $t('site.donateDirectOneTime', ['~$100']) }}

        <h3>{{ $t('site.donateOpportunityCosts') }}</h3>
        <p>{{ $t('site.donateOpportunityCostsDescription', ['250+']) }}</p>

        <h2> {{ $t('site.donationMethods') }} </h2>
        <div class="row homeFeatures">
            <div class="col-md-4">
                <div class="panel">
                    <div class="panel-content active">
                        <h1><strong>Paypal</strong></h1>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick">
                            <input type="hidden" name="hosted_button_id" value="TVHPXYCQVVHSA">
                            <input @click="handlePaypalButton" type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
                            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="panel">
                    <div class="panel-content active">
                        <h1><strong>{{ $t('site.cryptoCurrency') }}</strong></h1>
                       <pre>
ETH: 0x9E00255e4d6bA166CFD42aa32D21A40F894026CD
                       </pre>
                    </div>
                </div>
            </div>
        </div>

        <p v-html="$t('site.donationIncentive',['$10', '<i style=\'color:darkred\' class=\'fas fa-heart\'></i>'])">
        <p v-html="$t('site.donationIncentive2')">
        </p>

    </div>
</template>

<script>
    import ElvUserBadges from "@/components/ElvUserBadges";

    export default {
        components: { ElvUserBadges },
        name: 'Thanks',
        data () {
            return {
            }
        },
        methods: {
            handlePaypalButton: function() {
                this.$ga.event('Donate', "Started", "Website", 200);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Donate.vue